var _rect, _mask, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTechnicalkanban = function SvgTechnicalkanban(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.116,
    y: 0.761,
    width: 16.371,
    height: 1.806,
    rx: 0.848,
    stroke: "#203040",
    strokeWidth: 1.2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "technicalkanban_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.367 2.634v15.922c0 .8-.648 1.448-1.447 1.448h-.965c-.8 0-1.448-.648-1.448-1.448V2.634h3.86Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.567 2.634v15.922a2.648 2.648 0 0 1-2.647 2.648v-2.4c.136 0 .247-.11.247-.248V2.634h2.4Zm-3.612 18.57a2.647 2.647 0 0 1-2.648-2.648V2.634h2.4v15.922c0 .137.11.248.248.248v2.4ZM7.507 2.634h3.86-3.86Zm5.06 15.922a2.648 2.648 0 0 1-2.647 2.648h-.965a2.647 2.647 0 0 1-2.648-2.648h2.4c0 .137.11.248.248.248h.965c.136 0 .247-.11.247-.248h2.4Z",
    fill: "#203040",
    mask: "url(#technicalkanban_svg__a)"
  })));
};

export default SvgTechnicalkanban;